import React, { useState } from "react";
import { MdCompareArrows, MdArrowBack, MdPhotoFilter } from "react-icons/md";
import ImageConverter from "./ImageConverter";
import ImageCompressor from "./ImageCompressor";
import "./Tools.css";

const tools = [
  {
    id: "image-converter",
    title: "Image to WebP Converter",
    description: "Convert images to optimized WebP format with high quality.",
    icon: <MdCompareArrows size={32} />,
  },
  {
    id: "image-compressor",
    title: "Lossless Image Compressor",
    description: "Compress images with Sharp and adaptive quality without losing details.",
    icon: <MdPhotoFilter size={32} />,
  },
];

const Tools = () => {
  const [activeTool, setActiveTool] = useState(null);

  if (activeTool === "image-converter") {
    return (
      <div className="tools-container">
        <button className="btn-back" onClick={() => setActiveTool(null)}>
          <MdArrowBack size={20} /> Back to Tools
        </button>
        <ImageConverter />
      </div>
    );
  }

  if (activeTool === "image-compressor") {
    return (
      <div className="tools-container">
        <button className="btn-back" onClick={() => setActiveTool(null)}>
          <MdArrowBack size={20} /> Back to Tools
        </button>
        <ImageCompressor />
      </div>
    );
  }

  return (
    <div className="tools-container">
      <div className="tools-header">
        <h1>Tools</h1>
        <p>Productivity utilities for your workflow.</p>
      </div>

      <div className="tools-grid">
        {tools.map((tool) => (
          <div
            key={tool.id}
            className="tool-card"
            onClick={() => setActiveTool(tool.id)}
          >
            <div className="tool-icon">{tool.icon}</div>
            <h3>{tool.title}</h3>
            <p>{tool.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tools;
